import { lazyLoad } from '~/src/shared/utils/loadable';

export const ContactShowPage = lazyLoad(
  () => import('./index'),
  (module) => module.ContactShowPage,
);
